import { FC, useEffect, useRef, useState } from 'react'
import { AnimatePresence } from 'framer-motion'

import { Container } from 'components/container'
import { useDataContext } from 'context/data-context'
import { Logo as LogoKz } from './logo-tj'
import { Logo as LogoRu } from './logo-ru'
import { Menu, Toggle } from './menu'
import { Backdrop } from './menu/styled'
import { useMenuContext } from './menu/menu-context'
import { MenuContextProvider } from './menu/menu-context'
import { variants } from './variants'
import {
  StyledHeader,
  Logo,
  LogoContainer,
  MenuContainer,
  ObservedPoint,
} from './styled'
import { useLocation } from 'react-router-dom'

const BackdropWrapper = () => {
  const { isOpen, closeMenu } = useMenuContext()

  return (
    <AnimatePresence>
      {isOpen && (
        <Backdrop
          onClick={closeMenu}
          variants={variants}
          initial="initial"
          animate="enter"
          exit="exit"
        />
      )}
    </AnimatePresence>
  )
}

export const Header: FC<{ onTop?: boolean; isTransparent: boolean }> = ({
  onTop,
  isTransparent,
}) => {
  const { appLocale } = useDataContext()
  const pointRef = useRef<HTMLDivElement>(null)
  const [hasScrolled, setHasScrolled] = useState(false)
  const location = useLocation()
  const isHomepage = location.pathname === '/'
  const isAbout = location.pathname === '/about'
  const isVideo = location.pathname === '/video'

  useEffect(() => {
    const observer = new IntersectionObserver(([point]) => {
      setHasScrolled(!point.isIntersecting)
    })

    if (pointRef.current) {
      observer.observe(pointRef.current)
    }

    return () => observer.disconnect()
  }, [])

  return (
    <MenuContextProvider>
      <ObservedPoint ref={pointRef} />
      <StyledHeader
        $onTop={onTop}
        isTransparent={isTransparent}
        hasScrolled={hasScrolled}
      >
        <Container>
          <LogoContainer
            href="/"
            $isShareOpen={false}
            $isFullSize={isHomepage || isAbout || isVideo}
          >
            <Logo as={appLocale === 'ru' ? LogoRu : LogoKz} />
          </LogoContainer>

          {/* <Share isOpen={isShareOpen} onToggle={toggleShare} /> */}

          <MenuContainer isShareOpen={false}>
            <Toggle />
          </MenuContainer>

          <Menu />
        </Container>
      </StyledHeader>

      <BackdropWrapper />
    </MenuContextProvider>
  )
}
